
	import { defineComponent } from 'vue'
	import Dialog from 'primevue/dialog'
	import licenseDialogDescriptor from './LicenseDialogDescriptor.json'
	import LicenceTab from './LicenseTab.vue'
	import TabView from 'primevue/tabview'
	import TabPanel from 'primevue/tabpanel'
	import { mapState } from 'vuex'

	export default defineComponent({
		name: 'license-dialog',
		components: { Dialog, LicenceTab, TabView, TabPanel },
		data() {
			return {
				cpuNumber: Number,
				licenseDialogDescriptor
			}
		},
		props: {
			visibility: Boolean
		},
		emits: ['update:visibility'],
		methods: {
			closeDialog() {
				this.$emit('update:visibility', false)
			}
		},
		computed: {
			...mapState({
				user: 'user',
				licenses: 'licenses'
			})
		}
	})
